import { instance } from "./axios";

export const updateOtherMeasurements = (payload, id) => {
    try {
        return instance.put(`/visit/other/${id}`, payload);
    } catch (error) {
        throw error;
    }
};